import { Google, Pixall } from '../analytics/index.js';
export async function videoMediaEvent(_ref, option) {
  let {
    data = {},
    dataLayer,
    event
  } = _ref;
  Google.sendClickEvent({
    eventElement: 'video',
    eventAction: data.type,
    eventNonInteractive: data.originPage !== 'dhs',
    eventResult: data.originPage === 'dhs' ? `${data.originPage}::video-${data.videoName}::${data.eventLabel}` : `${data.originPage}::video::${data.eventLabel}::${data.videoName}`,
    eventData: {}
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'video',
    eventType: data.type === 'milestone' ? 'step' : data.type,
    label: data.originPage === 'dhs' ? `${data.originPage}::video-${data.videoName}::${data.eventLabel}` : `${data.originPage}::video::${data.eventLabel}::${data.videoName}`,
    hasListingType: data.hasListingType
  }, dataLayer, option);
  return event;
}
export default {
  videoMediaEvent
};